<template>
  <footer class="app-footer">
    <div class="footer-content">
      <p class="footer-text">
        {{ $t('footer.colofon') }}
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.app-footer {
  background-color: white;
  padding: 1rem;
  border-top: 1px solid #e0e0e0;
  margin-top: auto;
}

.footer-content {
  text-align: center;
}

.footer-text {
  margin: 0;
  color: #333;
  font-size: 0.875rem;
}

/* Desktop: respect sidebar margin */
@media only screen and (min-width: 600px) {
  .app-footer {
    margin-left: 5rem;
  }
}

/* Mobile: full width */
@media only screen and (max-width: 600px) {
  .app-footer {
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue